import { sessaoFetchLoading } from '@/service/fetch'

export async function extrato (beneficio) {
  let retorno = sessaoFetchLoading(`base`, `/consulta/extrato/${beneficio}`, 'GET', {}, false)
  return retorno
}

export async function hiscon (beneficio, loading = true) {
  if (loading) return sessaoFetchLoading(`base`, `/consulta/hiscon/${beneficio}`, 'GET', {}, false)
  return sessaoFetchLoading(`base`, `/consulta/hiscon/${beneficio}`, 'GET', {}, false)
}

export async function extratoOnline ({pedidoId, beneficio}) {
  return sessaoFetchLoading(`consig`, `/contrato/AtualizaContratosOnlineAsync/${pedidoId}/${beneficio}`, 'PATCH')
}

export async function higienizacaoTelefonesAssertivaAsync (cpf) {
  return sessaoFetchLoading('consig', `/api_fornecedores/HigienizacaoTelefonesAssertivaAsync/?cpf=${cpf}`, 'PATCH')
}

export async function consultaIN100 ({ beneficio }) {
  return sessaoFetchLoading(`consig`, `/contrato/AtualizarMargemBeneficio/${beneficio}`, 'PATCH')
}



// WEBPACK FOOTER //
// ./src/api/consultas.js